// extracted by mini-css-extract-plugin
export default {"formGrid":"styles_formGrid__XoW+q","buttonContainer":"styles_buttonContainer__c1G16","switchContainer":"styles_switchContainer__wBDiA","switchItem":"styles_switchItem__rfBdu"};